import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { changeClientPassword } from "../../api/clientAuthApi";
import { useClientAuth } from "../../auth/ClientAuthProvider";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";

export default function ClientChangePasswordPage() {
  const { clientUser, refresh } = useClientAuth();
  const paths = useClientPortalPaths();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (clientUser && !clientUser.mustChangePassword) {
    return <Navigate to={paths.dashboard} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (newPassword !== confirm) {
      setErrorMessage("New passwords do not match.");
      return;
    }
    setErrorMessage("");
    setSubmitting(true);
    try {
      await changeClientPassword({ currentPassword, newPassword });
      await refresh();
      navigate(paths.dashboard, { replace: true });
    } catch (error) {
      setErrorMessage(error.message || "Unable to update password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="panel-card auth-card">
      <h1>Choose a new password</h1>
      <p className="muted">
        Your administrator set a temporary password for {clientUser?.email || "this account"}. Replace
        it before continuing.
      </p>
      <form onSubmit={handleSubmit}>
        {errorMessage ? <p className="auth-error">{errorMessage}</p> : null}
        <label className="admin-users-field">
          <span>Temporary password</span>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
          />
        </label>
        <label className="admin-users-field">
          <span>New password</span>
          <input
            type="password"
            required
            autoComplete="new-password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
          />
        </label>
        <label className="admin-users-field">
          <span>Confirm new password</span>
          <input
            type="password"
            required
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
          />
        </label>
        <button type="submit" className="btn-primary" disabled={submitting}>
          {submitting ? "Saving…" : "Save password"}
        </button>
      </form>
    </section>
  );
}
